<template>
  <!-- <pre v-if="responseData"> testData={{ responseData }}</pre> -->
  <AdminBackground v-if="responseData">
    <div class="image-wrapper">
      <img src="@/assets/header/OKU.png" alt="OKU" class="pbt-image" />
      <!-- Center the line under the image -->
      <div class="line-under-image" />
    </div>
    <div class="content-wrapper">
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedYear"
            label="Tahun"
            :items="years"
            placeholder="Pilih Tahun"
            chips
            class="app-date-picker"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedPbt"
            label="Pihak Berkuasa Tempatan"
            :items="pbt"
            placeholder="Pilih PBT"
            class="app-date-picker"
            chips
            multiple
            closable-chips
          />
        </div>
      </div>

      <h2>PEMATUHAN UUK 34A (OKU) BAGI PEMBANGUNAN PROJEK BAHARU</h2>
      <div class="oku">
        <div
          v-for="(item, index) in OKUData"
          :key="index"
          class="oku-container"
        >
          <img
            src="@/assets/spah/box.png"
            alt="Image"
            class="responsive-image"
          />
          <div class="text-overlay">
            <div class="values-layered">
              <h3>{{ item.title }}</h3>
              <p class="number">
                {{ item.value }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-wrapper">
      <h2>PENYALAHGUNAAN PARKIR OKU</h2>
      <div class="oku">
        <div
          v-for="(item, index) in parkirData"
          :key="index"
          class="oku-container"
        >
          <img
            src="@/assets/spah/box.png"
            alt="Image"
            class="responsive-image"
          />
          <div class="text-overlay">
            <div class="values-layered">
              <h3>{{ item.title }}</h3>
              <p class="number">
                {{ item.value }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!--
        <MapNew />
      
        <div class="chart-wrapper">  
        <h2>SENARAI PENYALAHGUNAAN PARKIR OKU</h2>
        <table class="status-table">
        <thead>
        <tr>
        <th>No.</th>
        <th>Bulan</th>
        <th>Bilangan Parkir OKU</th>
        <th>Bilangan Kes Penyalahgunaan Parkir</th>
        <th>Amaun Kompaun</th>
        </tr>
        </thead>
        <tbody>
        <tr
        v-for="(item, index) in parkirDataTable"
        :key="index"
        >
        <td>{{ index + 1 }}</td>
        <td>{{ item.bulan }}</td>
        <td>{{ item.bilanganParkirOKU }}</td>
        <td>{{ item.bilanganKesPenyalahgunaanParkir }}</td>
        <td>{{ item.amaunKompaun }}</td>
        </tr>
        </tbody>
        </table>
        </div> 
      -->
    </div>

    <!--
      <div class="content-wrapper">
      <h2>BANGUNAN AWAM DAN TAMAN AWAM MESRA OKU</h2>

      <div class="chart-wrapper">  
      <table class="status-table">
      <thead>
      <tr>
      <th>No.</th>
      <th>Nama Bangunan Bangunan Awam / Taman Awam:</th>
      <th>Jenis</th>
      <th>Kategori</th>
      </tr>
      </thead>
      <tbody>
      <tr
      v-for="(item, index) in parkirDataTable"
      :key="index"
      >
      <td>{{ index + 1 }}</td>
      <td>{{ item.bulan }}</td>
      <td>{{ item.bilanganParkirOKU }}</td>
      <td>{{ item.bilanganKesPenyalahgunaanParkir }}</td>
      </tr>
      </tbody>
      </table>
      </div>
      <div class="chart-wrapper">  
      <Donut
      :chart-data="[
      { name: 'Cerun / Tanah Runtuh', value: 1061 },
      { name: 'Bangunan / Rumah', value: 1147 },
      { name: 'Jalan', value: 7609 },
      { name: 'Longkang / Banjir', value: 3415 },
      { name: 'Haiwan', value: 3079 },

      ]"
      chart-title="Statistik Aduan Mengikut Kategori"
      />
      </div>
      <MapNew />
      </div> 
    -->
    <PrimaryModule />
    <KejuruteraanAwamMenu />
  </AdminBackground>
</template>

<script setup>
import { useHttpService } from "@/httpService";
import { computed, onMounted, ref } from "vue";

const years = ref([]);
const states = ref(["Semua Negeri"]);
const pbt = ref([]);
const councils = ref([]);
const selectedYear = ref(2025);
const selectedsState = ref("Semua Negeri");
const selectedPbt = ref("Semua PBT");

//added by abdullah
definePage({
  alias: "/pages/pages/inspektorat/ahli-pbt",
  meta: {
    layout: "blank",
    public: true,
  },
});

const parkirDataTable = ref([
  {
    bulan: "Januari",
    bilanganParkirOKU: 27,
    bilanganKesPenyalahgunaanParkir: 74,
    amaunKompaun: "RM 3700",
  },
  {
    bulan: "Februari",
    bilanganParkirOKU: 27,
    bilanganKesPenyalahgunaanParkir: 108,
    amaunKompaun: "RM 5400",
  },
  {
    bulan: "Mac",
    bilanganParkirOKU: 27,
    bilanganKesPenyalahgunaanParkir: 129,
    amaunKompaun: "RM 6450",
  },
  {
    bulan: "April",
    bilanganParkirOKU: 27,
    bilanganKesPenyalahgunaanParkir: 92,
    amaunKompaun: "RM 4600",
  },
  {
    bulan: "Mei",
    bilanganParkirOKU: 27,
    bilanganKesPenyalahgunaanParkir: 121,
    amaunKompaun: "RM 6050",
  },
]);

const parkirOku = ref({
  bilanganKesPenyalahgunaanParkirOku: 0,
  jumlahKompaunRm: 0,
});

const penaltiOku = ref({
  bilanganProjekPembangunan: 0,
  bilanganProjekPatuh: 0,
  bilanganProjekTidakPatuh: 0,
  bilanganPenalti: 0,
});

const OKUData = computed(() => [
  {
    title: "Bil. Projek Pembangunan (Baharu)",
    value: penaltiOku.value.bilanganProjekPembangunan,
  },
  { title: "Bil. Projek Patuh", value: penaltiOku.value.bilanganProjekPatuh },
  {
    title: "Bil. Projek Tidak Patuh",
    value: penaltiOku.value.bilanganProjekTidakPatuh,
  },
  {
    title: "Bil. Penalti yang diambil",
    value: penaltiOku.value.bilanganPenalti,
  },
]);

const parkirData = computed(() => [
  {
    title: "Bil. Kes Penyalahgunaan Parkir OKU",
    value: parkirOku.value.bilanganKesPenyalahgunaanParkirOku,
  },
  {
    title: "Jumlah Kutipan Kompaun",
    value: `RM ${parkirOku.value.jumlahKompaunRm}`,
  },
]);

const { httpGet, numberWithCommas } = useHttpService();

const responseData = ref(null);

// async function loadDataFromApi(){
//   try {
//     const response = await httpGet('kejuruteraan-awam/oku')

//     responseData.value = response
//     parkirOku.value = response.data.parkir_oku.data
//     penaltiOku.value = response.data.penalti_oku.data

//     parkirOku.value = {
//       bilanganKesPenyalahgunaanParkirOku: numberWithCommas(response.data.parkir_oku.data.bilangan_kes_penyalahgunaan_parkir_oku || 0),
//       jumlahKompaunRm: numberWithCommas((response.data.parkir_oku.data.jumlah_kompaun_rm || 0).toFixed(2)),
//     }

//     penaltiOku.value = {
//       bilanganProjekPembangunan: response.data.penalti_oku.data.bilangan_projek_pembangunan || 0,
//       bilanganProjekPatuh: response.data.penalti_oku.data.bilangan_projek_patuh || 0,
//       bilanganProjekTidakPatuh: response.data.penalti_oku.data.bilangan_projek_tidak_patuh || 0,
//       bilanganPenalti: response.data.penalti_oku.data.bilangan_penalti || 0,
//     }

//   } catch (err) {
//     console.error('loadDataFromApi failed:', err)
//   }
// }

async function loadDataFromApi(
  year = selectedYear.value,
  state = selectedsState.value,
  pbtValue = selectedPbt.value
) {
  try {
    // Ensure we're working with a plain array for states
    const plainStates = toRaw(state);

    // Create query parameters for year and states
    // Create the query parameters manually
    let queryParams = `year=${year}`;
    console.log("Plain states:", plainStates);

    // Check if states are "Semua Negeri" and skip appending states[] if true
    if (!plainStates.includes("Semua Negeri")) {
      // Append each state to the query string with the desired 'states[]' format
      if (Array.isArray(plainStates)) {
        plainStates.forEach((state) => {
          const stateName =
            typeof state === "string" ? state : state.name || state.value;
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`;
          }
        });
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`;
      }
    }

    // Append councils[] if pbtValue is selected
    if (Array.isArray(pbtValue) && !pbtValue.includes("Semua PBT")) {
      // Append each PBT in the array to the query parameters
      pbtValue.forEach((pbt) => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`;
      });
    }

    // Construct the URL with the query parameters
    const url = `kejuruteraan-awam/oku?${queryParams}`;

    const response = await httpGet(url);

    years.value = response.years;

    // Populate states dropdown while excluding "Modified Pbt" and null values
    states.value = ["Semua Negeri"];
    response.states.forEach((state) => {
      if (state && state !== "Modified Pbt") {
        states.value.push(state);
      }
    });

    councils.value = response.councils;
    responseData.value = response;

    responseData.value = response;

    parkirOku.value = response.data.parkir_oku.data;
    penaltiOku.value = response.data.penalti_oku.data;

    parkirOku.value = {
      bilanganKesPenyalahgunaanParkirOku: numberWithCommas(
        response.data.parkir_oku.data.bilangan_kes_penyalahgunaan_parkir_oku ||
          0
      ),
      jumlahKompaunRm: numberWithCommas(
        (response.data.parkir_oku.data.jumlah_kompaun_rm || 0).toFixed(2)
      ),
    };

    penaltiOku.value = {
      bilanganProjekPembangunan:
        response.data.penalti_oku.data.bilangan_projek_pembangunan || 0,
      bilanganProjekPatuh:
        response.data.penalti_oku.data.bilangan_projek_patuh || 0,
      bilanganProjekTidakPatuh:
        response.data.penalti_oku.data.bilangan_projek_tidak_patuh || 0,
      bilanganPenalti: response.data.penalti_oku.data.bilangan_penalti || 0,
    };
  } catch (err) {
    console.error("loadDataFromApi failed:", err);
  }
}

function handleStateChange() {
  pbt.value = [];

  // Ensure selectedsState and selectedPbt are arrays
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : [];
  }
  if (!Array.isArray(selectedPbt.value)) {
    selectedPbt.value = selectedPbt.value ? [selectedPbt.value] : [];
  }

  // Remove "Semua Negeri" if other states are selected
  if (
    selectedsState.value.includes("Semua Negeri") &&
    selectedsState.value.length > 1
  ) {
    selectedsState.value = selectedsState.value.filter(
      (state) => state !== "Semua Negeri"
    );
  }

  // Remove "Semua PBT" if other PBTs are selected
  if (selectedPbt.value.includes("Semua PBT") && selectedPbt.value.length > 1) {
    selectedPbt.value = selectedPbt.value.filter((pbt) => pbt !== "Semua PBT");
  }

  // If no states are selected, reset to "Semua Negeri"
  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"];
  }

  // If no PBTs are selected, reset to "Semua PBT"
  if (selectedPbt.value.length === 0) {
    selectedPbt.value = ["Semua PBT"];
  }

  if (selectedsState.value.includes("Semua Negeri")) {
    // Add all councils from all states
    Object.keys(councils.value).forEach((state) => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach((councilKey) => {
          const council = councils.value[state][councilKey];
          if (council && council.value) {
            pbt.value.push(council.value);
          }
        });
      }
    });
  } else {
    // Only add councils for the selected states
    selectedsState.value.forEach((state) => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach((councilKey) => {
          const council = councils.value[state][councilKey];
          if (council && council.value) {
            pbt.value.push(council.value);
          }
        });
      }
    });
  }

  console.log("Filtered PBT:", pbt.value);
}

onMounted(() => {
  loadDataFromApi();
});

//this is for setting the inital values for pbts as semua negeri id default option for Negeri (state)
watch(
  councils,
  (newValue) => {
    if (newValue) handleStateChange();
  },
  { immediate: true }
);

watch(
  [selectedYear, selectedsState, selectedPbt],
  () => {
    loadDataFromApi(
      selectedYear.value,
      selectedsState.value,
      selectedPbt.value
    );
  },
  { immediate: true }
);
</script>

<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%); /* Background for content */
  border-radius: 20px; /* Rounded corners */
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2); /* Shadow for depth */
  margin: 20px 0;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  max-width: 70%; /* Adjusted size */
  height: auto;
}

.line-under-image {
  width: 70%; /* Match width to the image size */
  height: 5px;
  background-color: white;
  border-radius: 5px;
  margin-top: 10px;
}

h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 10px;
  text-align: left;
  width: 100%;
}

/* Flexbox container for the input fields */
.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* Styles for each input field */
.input-item {
  flex: 1;
  margin-right: 15px;
}

/* Remove margin for the last item */
.input-item:last-child {
  margin-right: 0;
}

.oku {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;
  margin-bottom: 20px;
}

.oku-container {
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.responsive-image {
  width: 100%;
  height: auto;
  display: block;
}

.text-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-family: Arial, sans-serif;
  text-align: center; /* Centers the text horizontally */
}

.values-layered h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #150069;
  text-align: center;
}

.number {
  font-size: 20px;
  font-weight: bold;
  color: #a80000;
  text-align: center;
}

.chart-wrapper {
  width: 100%;
  max-width: 1200px;
  margin-bottom: 50px;
  padding: 20px;
  background: rgba(255, 254, 254, 0.8);
  border-radius: 10px;
  height: auto;
}

.status-table {
  width: 100%;
  border-collapse: collapse;
  background-color: white; /* White background for the table itself */
}

.status-table th,
.status-table td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
}

.status-table th {
  background-color: #f2f2f2;
  font-weight: bold;
  color: #333;
  text-transform: uppercase;
}

.status-table td {
  color: #000;
}

/* Responsive styles */
@media (max-width: 768px) {
  .input-row {
    flex-direction: column;
    gap: 10px;
  }

  .oku {
    grid-template-columns: repeat(2, 1fr);
  }

  h2 {
    font-size: 1.3rem;
  }

  .values-layered h3 {
    font-size: 12px;
  }

  .number {
    font-size: 18px;
  }

  .chart-wrapper {
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .pbt-image {
    max-width: 90%;
  }

  .line-under-image {
    width: 90%;
  }

  h2 {
    font-size: 1.1rem;
  }

  .oku {
    grid-template-columns: 1fr;
  }

  .values-layered h3 {
    font-size: 11px;
  }

  .number {
    font-size: 16px;
  }

  .input-item {
    width: 100%;
    margin-right: 0;
  }

  .oku-container {
    width: 100%;
  }

  .chart-wrapper {
    padding: 10px;
    margin-bottom: 30px;
  }
}
</style>
